/* eslint-disable prettier/prettier */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useState, useEffect, useRef } from 'react';

import {
  Box,
  Button,
  ClickAwayListener,
  Fade,
  IconButton,
  Popper,
  PopperPlacementType,
} from '@material-ui/core';

import { useTranslation } from 'react-i18next';

import Notification from 'components/Tools/Notification';
import { useMobile } from 'hooks/Mobile';
import { getCookie } from 'utils/cookies';
import { useTema } from 'hooks/Theme';
import { useSidebar } from 'hooks/Sidebar';
import {
  BoxOptions,
  Container,
  Main,
  HeaderContainer,
  CompanyName,
  UserInfo,
} from './styles';
import Sidebar from '../Sidebar';
import About from '../About';
import { ThemeToggle } from '../../Tools/ThemeToggle';
import { useAuth } from '../../../hooks/Auth';
import { ArrowLogout, UserIcon } from './icons';

interface ISignedLayoutProps {
  loged?: boolean;
  children?: React.ReactNode;
}

const SignedLayout: React.FC<ISignedLayoutProps> = ({ children }) => {
  const { isFixed } = useSidebar();
  const { isMobileDevice } = useMobile();
  const [closed, setClosed] = useState(true);
  const client = getCookie('@pdamodules::descricaoCliente');

  const [animate, setAnimate] = useState(false);
  const anchorRef = useRef<HTMLButtonElement>(null);
  const [open, setOpen] = useState(true);
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const [placement, setPlacement] = useState<PopperPlacementType>();

  const { toggleTheme } = useTema();
  const { signOut, user } = useAuth();

  const { t } = useTranslation();

  const environment_type = String(process.env.REACT_APP_ENVIRONMENTTYPE);

  const Logout = useCallback(() => {
    signOut();
  }, [signOut]);

  const handleClick =
    (newPlacement: PopperPlacementType) =>
    (event: React.MouseEvent<HTMLButtonElement>) => {
      setAnchorEl(event.currentTarget);
      setOpen(prev => placement !== newPlacement || !prev);
      setAnimate(true);
      setPlacement(newPlacement);
    };

  const handleClose = (event: React.MouseEvent<EventTarget>) => {
    if (
      anchorRef.current &&
      anchorRef.current.contains(event.target as HTMLElement)
    ) {
      return;
    }
    setAnimate(false);
    setOpen(false);
  };

  useEffect(() => {
    if (isMobileDevice) {
      setClosed(false);
    }
  }, [isMobileDevice]);

  return (
    <>
      <Container closed={closed} fixed={isFixed}>
        <HeaderContainer>
          {!isMobileDevice && (
            <>
              <div className="invisible-block" />
              <CompanyName>{client}</CompanyName>
            </>
          )}
          <div className="userInteractions">
            {isMobileDevice ? (
              <Notification />
            ) : (
              <ThemeToggle toggleTheme={toggleTheme} />
            )}
            <UserInfo environment_type={environment_type}>
              {isMobileDevice ? (
                <ThemeToggle toggleTheme={toggleTheme} />
              ) : (
                <Notification />
              )}
              <div className="greetings">
                <p>
                  {t('components.user.greetings')},
                  <span className="userName"> {user?.data.nome}</span>
                </p>

                <span className="environment-type">
                  {environment_type || 'não informado'}
                </span>
              </div>
              <div className="user">
                <IconButton id="btn" onClick={handleClick('top')}>
                  <UserIcon />
                </IconButton>
                {isMobileDevice && (
                  <CompanyName isMobile={isMobileDevice}>{client}</CompanyName>
                )}
                {/* @ts-ignore */}
                <Box className="popper-box">
                  <Popper
                    open={open}
                    anchorEl={anchorEl}
                    onClick={Logout}
                    placement={placement}
                    transition
                    className="popper"
                    style={{ zIndex: 999999 }}
                  >
                    <ClickAwayListener onClickAway={handleClose}>
                      <Fade in={animate}>
                        <BoxOptions>
                          <Button className="logoutBtn" ref={anchorRef}>
                            <p>Sign out</p>
                            <ArrowLogout />
                          </Button>
                        </BoxOptions>
                      </Fade>
                    </ClickAwayListener>
                  </Popper>
                </Box>
              </div>
              <About />
            </UserInfo>
          </div>
        </HeaderContainer>
        <Main onClick={() => isMobileDevice && setClosed(false)} id="main">
          <>
            {children}
            <div className="shape shapeOne" />
          </>
        </Main>
      </Container>
      <Sidebar />
    </>
  );
};

export default SignedLayout;
